import {
  TLearningCurveDTO,
  TRESPONSE_ORDER_DETAILS_ALL_LEARNING_CURVES,
  TRESPONSE_LL_LEARNING_CURVE_DETAILS,
  TRESPONSE_LL_LEARNING_CURVE_BY_FACTORY_OTL,
} from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableInfo, TTableCellTree } from '../../table.type';

export const LL_LEARNING_CURVE_TABLE_MODEL = {
  createFactoryOtlLevelModel: (learningCurveData: TRESPONSE_LL_LEARNING_CURVE_BY_FACTORY_OTL) => {
    const dayCount = learningCurveData.learning_curve_info?.day_count || 0;
    const efficiencyData = learningCurveData.learning_curve_info?.efficiencies || [];

    return ModifiersZTableModel.createTableModel(
      [learningCurveData],
      {
        edit: {
          hasAddRow: false,
          stickyType: 'RIGHT',
        },
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'FACTORY NAMES',
            stickyType: 'LEFT',
          },
          {
            type: 'TEXT_CELL',
            text: 'LEARNING CURVE',
          },
          ...(dayCount > 0 ? LL_LEARNING_CURVE_TABLE_MODEL.getHeaderConfigForDaysOtl(dayCount) : []),
          {
            type: 'TEXT_CELL',
            text: '',
            widthInPx: 32,
          },
        ],
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.factory_info.name,
            },
            {
              type: 'TEXT_CELL',
              text: item.learning_curve_info?.name || '',
              hrefActionCB: item.learning_curve_info?.name ? 'LEARNING_CURVE' : undefined,
            },
            ...(dayCount > 0 ? LL_LEARNING_CURVE_TABLE_MODEL.getRowCellsForDaysOtl(dayCount, efficiencyData) : []),
            {
              type: 'ACTION_CELL',
              actionType: 'DELETE',
              asIcon: true,
            },
          ],
        };
      },
    );
  },

  createStripLevelModel: (
    learningCurveData: TRESPONSE_LL_LEARNING_CURVE_DETAILS['learning_curve_info'],
    learningCurves: TRESPONSE_ORDER_DETAILS_ALL_LEARNING_CURVES['learning_curves'],
  ) => {
    console.log('createStripLevelModel =>', learningCurveData);
    return ModifiersZTableModel.createTableModel(
      [learningCurveData],
      {
        edit: {
          hasAddRow: false,
          hasDeleteRow: true,
          stickyType: 'RIGHT',
        },
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'NAMES',
            stickyType: 'LEFT',
            liftedInput: {
              input: {
                type: 'DROPDOWN',
                options: learningCurves.map((d) => ({ value: d.name, displayName: d.name })),
                setValue: (v) => {
                  console.log('Names set value =>', v);
                  return v.name;
                },
              },
              metadata: {
                keyName: 'name',
                noEditsInTable: true,
              },
            },
          },
          ...LL_LEARNING_CURVE_TABLE_MODEL.getHeaderConfigForDaysStrip(learningCurveData.day_count),
        ],
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.name,
            },
            ...LL_LEARNING_CURVE_TABLE_MODEL.getRowCellsForDaysStrip(learningCurveData.day_count, item),
          ],
        };
      },
    );
  },

  getHeaderConfigForDaysStrip: (dayCount: TRESPONSE_LL_LEARNING_CURVE_DETAILS['learning_curve_info']['day_count']) => {
    const acc: TTableInfo['header']['cells'] = [];
    for (let i = 0; i < dayCount; i++) {
      acc.push({
        type: 'TEXT_CELL',
        text: 'Day' + (i + 1),
        liftedInput: {
          input: {
            type: 'INPUT',
            subType: 'number',
            setValue: (value: TLearningCurveDTO) => {
              return value.efficiencies.find((eff) => eff.day === i + 1)?.efficiency;
            },
            placeholder: 'Enter percent',
            min: 0,
            isMinInclusive: false,
          },
          metadata: {
            keyName: 'Day' + (i + 1),
          },
        },
      } as TTableInfo['header']['cells'][number]);
    }
    return acc;
  },

  getRowCellsForDaysStrip: (
    dayCount: TRESPONSE_LL_LEARNING_CURVE_DETAILS['learning_curve_info']['day_count'],
    item: TRESPONSE_LL_LEARNING_CURVE_DETAILS['learning_curve_info'],
  ) => {
    const acc: TTableCellTree[] = [];
    for (let i = 0; i < dayCount; i++) {
      acc.push({
        type: 'TEXT_CELL',
        text: item.efficiencies.find((eff) => eff.day === i + 1)?.efficiency || 0,
      });
    }
    return acc;
  },

  getHeaderConfigForDaysOtl: (dayCount: number) => {
    const acc: TTableInfo['header']['cells'] = [];
    for (let i = 0; i < dayCount; i++) {
      acc.push({
        type: 'TEXT_CELL',
        text: 'Day' + (i + 1),
      } as TTableInfo['header']['cells'][number]);
    }
    return acc;
  },

  getRowCellsForDaysOtl: (dayCount: number, efficiencies: { day: number; efficiency: number }[]) => {
    const acc: TTableCellTree[] = [];
    for (let i = 0; i < dayCount; i++) {
      acc.push({
        type: 'TEXT_CELL',
        text: efficiencies.find((eff) => eff.day === i + 1)?.efficiency || 0,
      });
    }
    return acc;
  },
};
